// utils/MembershipWatchGuard.jsx
import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import ApiServices from '../services/apiServices';

const MembershipWatchGuard = () => {
  const [isAllowed, setIsAllowed] = useState(null); // null = loading, true/false = decision
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      const pathParts = location.pathname.split('/');
      const type = pathParts[2]; // 'promo', 'movie', 'series', etc.

      // Always allow promo videos
      if (type === 'promo') {
        setIsAllowed(true);
        setIsChecking(false);
        return;
      }

      // If no user → deny access
      if (!user) {
        setIsAllowed(false);
        setIsChecking(false);
        return;
      }

      try {
        // Validate membership
        const result = await ApiServices.callGetAPI('membership/validate');
        
        if (result.status === 200 && result.data.valid && result.data.data.premiumuser > 0) {
          setIsAllowed(true);
        } else {
          setIsAllowed(false);
        }
      } catch (error) {
        console.error('Membership validation error:', error);
        setIsAllowed(false);
      } finally {
        setIsChecking(false);
      }
    });

    return () => unsubscribe();
  }, [location.pathname]);

  if (isChecking) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        color: '#fff',
        fontSize: '1.5rem'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAllowed) {
    // Redirect to subscription page if not premium, or login if not logged in
    const redirectTo = location.pathname.includes('promo') ? '/login' : '/login';
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default MembershipWatchGuard;